/* eslint-disable */
import KeenSlider from 'keen-slider';

export default function initQuoteImageCarousel() {
    document.querySelectorAll('.quote-carousel-section').forEach((sect) => {
        let imageCarousel = null;
        let quoteCarousel = null;
        let currentSlide = 0;
        let canloop = false;
        let autoplay = 0;

        const autoplayInteractStop = true;


        const init = () => {
            const section = sect;
            const autoplayAttr = section.getAttribute('data-autoplay');
            const loopAttr = section.getAttribute('data-loop');
            const autoplayInteractStopAttr = section.getAttribute('data-autoplay-interact-stop');

            if (autoplayAttr) {
                autoplay = parseInt(autoplayAttr, 10);
            }

            if (loopAttr) {
                canloop = loopAttr === 'true';
            }

            if (autoplayInteractStopAttr) {
                autoplayInteractStop = autoplayInteractStopAttr === 'true';
            }

            initImageCarousel(section);
            initQuoteCarousel(section);
            initNavControls(section);
			initParagraphCount(section);

            if (autoplay > 0) {
                setTimeout(() => {
                    imageCarousel.next();
                    quoteCarousel.next();
                }, autoplay);
            }
        };

        const initImageCarousel = (section) => {
            // image carousel //
            const container = section.querySelector('.quote-carousel-images');
            const slides = container.querySelectorAll('.quote-carousel-image-item');

            if (container === null) return false;

            const options = {
                selector: slides,
                defaultAnimation: {
                    duration: 1000,
                },
                slides: {
                    origin: 'auto',
                    perView: 1,
                    spacing: 0,
                },
                slidesPerView: 1,
                drag: true,
                loop: canloop,
                renderMode: 'precision',
                rubberband: false,
                centered: true,
            };

            imageCarousel = new KeenSlider(container,
                options, [
                (carousel) => {
                    carousel.on("slideChanged", (e) => {
                        quoteCarousel.moveToIdx(imageCarousel.track.details.abs, false, { duration: 1000 });
                    });
                },
            ]
            );
        };


        const initQuoteCarousel = (section) => {

            // image carousel //
            const container = section.querySelector('.quote-carousel-cards');
            const slides = container.querySelectorAll('.quote-carousel-card');

            if (container === null) return false;

            const options = {
                selector: slides,
                defaultAnimation: {
                    duration: 1000,
                },
                slides: {
                    origin: 'auto',
                    perView: 1,
                    spacing: 0,
                },
                slidesPerView: 1,
                drag: true,
                loop: canloop,
                renderMode: 'precision',
                rubberband: false,
                centered: true,
            };

            quoteCarousel = new KeenSlider(container,
                options, [
                (carousel) => {
                    carousel.on("slideChanged", (e) => {
                        imageCarousel.moveToIdx(quoteCarousel.track.details.abs, false, { duration: 1000 });
                    });
                },
            ]
            );
        };

        const initNavControls = (section) => {
            const container = section.querySelector('.carousel-nav-container');

            if (container === null) return false;

            const indicators = container.querySelector('.carousel-controls-indicators');
            const prev = section.querySelector('.carousel-nav-prev');
            const next = section.querySelector('.carousel-nav-next');

            if (indicators) {
                const indicatorChildren = indicators.children;

                for (let i = 0; i < indicatorChildren.length; i++) {
                    const indicator = indicatorChildren[i];

                    indicator.addEventListener('click', () => {
                        if (autoplayInteractStop) autoplay = 0;
                        imageCarousel.moveToIdx(i, false, { duration: 1000 });
                        quoteCarousel.moveToIdx(i, false, { duration: 1000 });
                    });
                }

                imageCarousel.on('slideChanged', (s) => {
                    const child = indicatorChildren[imageCarousel.track.details.rel];
                    for (let i = 0; i < indicatorChildren.length; i++) {
                        indicatorChildren[i].classList.remove('active');
                    }
                    child.classList.add('active');
                });
            }

            if (prev && next) {
                prev.addEventListener('click', (e) => {
                    e.preventDefault();
                    imageCarousel.prev();
                    quoteCarousel.prev();
                    if (autoplayInteractStop) autoplay = 0;
                });

                next.addEventListener('click', (e) => {
                    e.preventDefault();
                    imageCarousel.next();
                    quoteCarousel.next();
                    if (autoplayInteractStop) autoplay = 0;
                });

                imageCarousel.on('slideChanged', (e) => {
                    if (imageCarousel.track.details.rel === 0) {
                        section.classList.add('carousel-item-first-visible');
                        container.classList.add('carousel-item-first-visible');
                        if (!canloop) {
                            prev.classList.add('disabled');
                        }
                    } else {
                        section.classList.remove('carousel-item-first-visible');
                        container.classList.remove('carousel-item-first-visible');
                        prev.classList.remove('disabled');
                    }

                    if (imageCarousel.track.details.rel === imageCarousel.track.details.maxIdx) {
                        section.classList.add('carousel-item-last-visible');
                        container.classList.add('carousel-item-last-visible');
                        if (!canloop) {
                            next.classList.add('disabled');
                        }
                    } else {
                        section.classList.remove('carousel-item-last-visible');
                        container.classList.remove('carousel-item-last-visible');
                        next.classList.remove('disabled');
                    }
                });

                if (!canloop) {
                    prev.classList.add('disabled');
                }

                if (imageCarousel.track.details.length < 1) {
                    container.style.display = 'none';
                }
            }
        }

		const initParagraphCount = (section) => {
			const paragraphs = section.querySelectorAll('.blockquote p');
			paragraphs.forEach((paragraph) => {
				const charCount = paragraph.innerText.length;
				// console.log(charCount);
				if (charCount > 250) {
					paragraph.classList.add('long-content');
				} else {
					paragraph.classList.add('short-content');
				}
			});
		}

        init();
    });

}
